<template>
  <component :is="tag" :id="id" class="TypographyInputHint" :class="className">
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: {
    id: {
      type: String
    },
    tag: {
      type: String,
      default: 'p'
    },
    isDanger: Boolean
  },

  computed: {
    className () {
      return {
        '-danger': this.isDanger
      }
    }
  }
}
</script>

<style lang="scss">
@import './src/assets/styles/colors.scss';

.TypographyInputHint {
  font-size: 14.6px;
  line-height: 1.43;
  font-weight: 400;
  margin-top: 4px;
  color: $color-pale-sky;

  &.-danger {
    color: $color-thunderbird;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/typography/TypographyInputHint.vue